// extracted by mini-css-extract-plugin
module.exports = {"videobottom":"BottomText_videobottom__1Rqmq","title":"BottomText_title__1sZyS","text":"BottomText_text__2Pq3K"};